import {
  Facility,
  Consumer,
  Employee,
  Vehicle,
  Address
} from '../index';

declare var Object: any;
export interface TripRecInterface {
  "manifestRecId"?: string;
  "requestID": string;
  "isRoundTrip"?: boolean;
  "origin"?: string;
  "destination"?: string;
  "date": Date;
  "dateInt": number;
  "time"?: string;
  "apptTime"?: string;
  "pickUpTime"?: string;
  "dropOffTime"?: string;
  "trip"?: number;
  "seat"?: number;
  "serviceType"?: string;
  "mealsUnitsV2"?: any;
  "mealsUnits1"?: number;
  "mealsUnits2"?: number;
  "mealsUnits3"?: number;
  "mealsUnits4"?: number;
  "mealsUnits5"?: number;
  "broker"?: string;
  "tripId"?: string;
  "brokerNote"?: string;
  "cancelled"?: boolean;
  "dailyNote"?: string;
  "oneTimeTrip"?: boolean;
  "didNotAttend"?: boolean;
  "distance"?: number;
  "duration"?: number;
  "destUpdatedByDriver"?: boolean;
  "meta"?: any;
  "id"?: any;
  "tenantId"?: number;
  "consumerId"?: number;
  "employeeId"?: number;
  "vehicleId"?: number;
  "escortId"?: number;
  "addressId"?: number;
  tenant?: Facility;
  consumer?: Consumer;
  employee?: Employee;
  vehicle?: Vehicle;
  escort?: Employee;
  address?: Address;
}

export class TripRec implements TripRecInterface {
  "manifestRecId": string;
  "requestID": string;
  "isRoundTrip": boolean;
  "origin": string;
  "destination": string;
  "date": Date;
  "dateInt": number;
  "time": string;
  "apptTime": string;
  "pickUpTime": string;
  "dropOffTime": string;
  "trip": number;
  "seat": number;
  "serviceType": string;
  "mealsUnitsV2": any;
  "mealsUnits1": number;
  "mealsUnits2": number;
  "mealsUnits3": number;
  "mealsUnits4": number;
  "mealsUnits5": number;
  "broker": string;
  "tripId": string;
  "brokerNote": string;
  "cancelled": boolean;
  "dailyNote": string;
  "oneTimeTrip": boolean;
  "didNotAttend": boolean;
  "distance": number;
  "duration": number;
  "destUpdatedByDriver": boolean;
  "meta": any;
  "id": any;
  "tenantId": number;
  "consumerId": number;
  "employeeId": number;
  "vehicleId": number;
  "escortId": number;
  "addressId": number;
  tenant: Facility;
  consumer: Consumer;
  employee: Employee;
  vehicle: Vehicle;
  escort: Employee;
  address: Address;
  constructor(data?: TripRecInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `TripRec`.
   */
  public static getModelName() {
    return "TripRec";
  }

  /**
  * This method creates an instance of TripRec for dynamic purposes.
  **/
  public static factory(data: TripRecInterface): TripRec{
    return new TripRec(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TripRec',
      plural: 'TripRecs',
      path: 'TripRecs',
      idName: 'id',
      properties: {
        "manifestRecId": {
          name: 'manifestRecId',
          type: 'string'
        },
        "requestID": {
          name: 'requestID',
          type: 'string'
        },
        "isRoundTrip": {
          name: 'isRoundTrip',
          type: 'boolean',
          default: false
        },
        "origin": {
          name: 'origin',
          type: 'string'
        },
        "destination": {
          name: 'destination',
          type: 'string'
        },
        "date": {
          name: 'date',
          type: 'Date'
        },
        "dateInt": {
          name: 'dateInt',
          type: 'number'
        },
        "time": {
          name: 'time',
          type: 'string'
        },
        "apptTime": {
          name: 'apptTime',
          type: 'string'
        },
        "pickUpTime": {
          name: 'pickUpTime',
          type: 'string'
        },
        "dropOffTime": {
          name: 'dropOffTime',
          type: 'string'
        },
        "trip": {
          name: 'trip',
          type: 'number',
          default: 0
        },
        "seat": {
          name: 'seat',
          type: 'number',
          default: 0
        },
        "serviceType": {
          name: 'serviceType',
          type: 'string'
        },
        "mealsUnitsV2": {
          name: 'mealsUnitsV2',
          type: 'any',
          default: <any>null
        },
        "mealsUnits1": {
          name: 'mealsUnits1',
          type: 'number'
        },
        "mealsUnits2": {
          name: 'mealsUnits2',
          type: 'number'
        },
        "mealsUnits3": {
          name: 'mealsUnits3',
          type: 'number'
        },
        "mealsUnits4": {
          name: 'mealsUnits4',
          type: 'number'
        },
        "mealsUnits5": {
          name: 'mealsUnits5',
          type: 'number'
        },
        "broker": {
          name: 'broker',
          type: 'string'
        },
        "tripId": {
          name: 'tripId',
          type: 'string'
        },
        "brokerNote": {
          name: 'brokerNote',
          type: 'string'
        },
        "cancelled": {
          name: 'cancelled',
          type: 'boolean'
        },
        "dailyNote": {
          name: 'dailyNote',
          type: 'string'
        },
        "oneTimeTrip": {
          name: 'oneTimeTrip',
          type: 'boolean'
        },
        "didNotAttend": {
          name: 'didNotAttend',
          type: 'boolean'
        },
        "distance": {
          name: 'distance',
          type: 'number'
        },
        "duration": {
          name: 'duration',
          type: 'number'
        },
        "destUpdatedByDriver": {
          name: 'destUpdatedByDriver',
          type: 'boolean'
        },
        "meta": {
          name: 'meta',
          type: 'any',
          default: <any>null
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "tenantId": {
          name: 'tenantId',
          type: 'number'
        },
        "consumerId": {
          name: 'consumerId',
          type: 'number'
        },
        "employeeId": {
          name: 'employeeId',
          type: 'number'
        },
        "vehicleId": {
          name: 'vehicleId',
          type: 'number'
        },
        "escortId": {
          name: 'escortId',
          type: 'number'
        },
        "addressId": {
          name: 'addressId',
          type: 'number'
        },
      },
      relations: {
        tenant: {
          name: 'tenant',
          type: 'Facility',
          model: 'Facility',
          relationType: 'belongsTo',
                  keyFrom: 'tenantId',
          keyTo: 'id'
        },
        consumer: {
          name: 'consumer',
          type: 'Consumer',
          model: 'Consumer',
          relationType: 'belongsTo',
                  keyFrom: 'consumerId',
          keyTo: 'id'
        },
        employee: {
          name: 'employee',
          type: 'Employee',
          model: 'Employee',
          relationType: 'belongsTo',
                  keyFrom: 'employeeId',
          keyTo: 'id'
        },
        vehicle: {
          name: 'vehicle',
          type: 'Vehicle',
          model: 'Vehicle',
          relationType: 'belongsTo',
                  keyFrom: 'vehicleId',
          keyTo: 'id'
        },
        escort: {
          name: 'escort',
          type: 'Employee',
          model: 'Employee',
          relationType: 'belongsTo',
                  keyFrom: 'escortId',
          keyTo: 'id'
        },
        address: {
          name: 'address',
          type: 'Address',
          model: 'Address',
          relationType: 'belongsTo',
                  keyFrom: 'addressId',
          keyTo: 'id'
        },
      }
    }
  }
}
